import '../style/main.css';
import Meta from '../components/Meta.js';
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';

function Documents() {
	return (
		<>
			<Meta title='Documents' />
			<Header />
			<div class='main-content'>
				<h2>Documents</h2>
			</div>
			<Footer />  
		</>
	);
};

export default Documents;
